import Dexie from "dexie";
import { TblBidDataDisplay } from "../models/BidDataDisplay";
import { TblUserData } from "../models/UserData";
import { TblFlightDataMaster } from "../models/FlightData";
import { TblColumnDefinitions, TblVacColumnDefinitions } from "../models/ColumnDefintion";
import { TblStatePresetVersionInfo } from "../models/StatePresetVersionInfo";
import { TblPreset } from "../models/TblPreset";
import { TblBidList } from "../models/TblBidList";
import { TblUserBidReceipt } from "../models/TblUserBidReceipt";
import { TblFAList } from "../models/TblFAList";
import { TblCrewbidFiles } from "../models/TblCrewbidFiles";
import { TblBidFileName } from "../models/TblBidFileName";
import { TblASortData } from "../models/TblASortData";
import { TblCommutFlghtChanges } from "../models/TblCommutFlghtChanges";

export class CrewBidAppDb extends Dexie {
  BidDataDisplay: Dexie.Table<TblBidDataDisplay, string>;
  UserData: Dexie.Table<TblUserData, string>;
  FlightDataMaster: Dexie.Table<TblFlightDataMaster, number>;
  INI_ColumnDefinitions: Dexie.Table<TblColumnDefinitions, string>;
  INI_VacColumnDefinitions: Dexie.Table<TblVacColumnDefinitions, string>;
  StatePresetVersionInfo: Dexie.Table<TblStatePresetVersionInfo>;
  Preset: Dexie.Table<TblPreset, string>;
  BidListData: Dexie.Table<TblBidList, number>;
  UserBidReceipt: Dexie.Table<TblUserBidReceipt, number>;
  FAListData: Dexie.Table<TblFAList, number>;
  CrewbidFiles: Dexie.Table<TblCrewbidFiles, string>;
  BidFileNames: Dexie.Table<TblBidFileName, number>;
  ASortData: Dexie.Table<TblASortData, number>;
  CommutFlghtChanges: Dexie.Table<TblCommutFlghtChanges, string>
  constructor() {
    super("CrewBidDB");
    const db = this;

    db.version(1).stores({
      BidDataDisplay:
        "++id, Domicile, Position, Round, Month, offline, Year, fieldId, size, modified, created, EmpNum, showDelete, bidPeriodStartDate, bidPeriodEndDate, lines, trips, state, vacationLines, vacationEomLines, eomLines, isEBGUser, swaptimizerServerData, swaptimizerLines, isHistoricalBid, LastSubmitedDate, secretEmpNum",
    });
    db.version(2).stores({
      UserData:
        "++id,empId,IsAuthorized,AuthRequestId,Message,Type,ExpirationDate,CBExpirationDate,WBExpirationDate,IsFree,IsYearlySubscribed,IsMonthlySubscribed,TopSubscriptionLine,SecondSubscriptionLine,ThirdSubscriptionLine,EmailId, Modified, AppSettings",
    });
    db.version(3).stores({
      FlightDataMaster: "++id, flightDataCompressedStr,flightDataName, flightDataVersion",
    });
    db.version(4).stores({
      INI_ColumnDefinitions: "++id,empNum, version, columnDefinitionJsonString",
    });
    db.version(5).stores({
      StatePresetVersionInfo:
        "++id, empId, presetVersion, stateVersion, presetLastUpdatedTime, stateLastUpdatedTime, presetLastUpdatedDate, stateLastUpdatedDate, isStateModified, isPresetModified,  fileid",
    });
    db.version(6).stores({
      Preset: "++id,empId,presetData,presetName,position",
    });
    db.version(7).stores({
      BidListData: "++id,empNum,lineData,fieldId",
    });
    db.version(8).stores({
      UserBidReceipt: "++id, submittedBy, submittedFor, bidReceipt",
    });
    db.version(9).stores({
      FAListData: "++id, employeeId, faList",
    });
    db.version(10).stores({
      CrewbidFiles: "++id, fileName, fileContent",
    });
    db.version(11).stores({
      BidFileNames: "++id, empId, fieldId, bidFiles",
    });
    db.version(12).stores({
      ASortData: "++id, empNum, fieldId, submittedResult, bidAwards",
    });
    db.version(13).stores({
      CommutFlghtChanges: "++id, fileName, fileContent",
    });
    db.version(14).stores({
      INI_VacColumnDefinitions: "++id,empNum, version, columnDefinitionJsonString",
    });
    db.open();
    db.BidDataDisplay.mapToClass(TblBidDataDisplay);
    db.UserData.mapToClass(TblUserData);
    db.INI_ColumnDefinitions.mapToClass(TblColumnDefinitions);
    db.INI_VacColumnDefinitions.mapToClass(TblColumnDefinitions);
    db.Preset.mapToClass(TblPreset);
    db.UserBidReceipt.mapToClass(TblUserBidReceipt);
    db.FAListData.mapToClass(TblFAList);
    db.CrewbidFiles.mapToClass(TblCrewbidFiles);
    db.BidFileNames.mapToClass(TblBidFileName);
    db.ASortData.mapToClass(TblASortData);
    db.BidListData.mapToClass(TblBidList);
  }
}

export let db = new CrewBidAppDb();
